<template>
  <kst-actions :actions="availActions"/>
</template>

<script>
import Model from "../DlvModel.js";

export default {
  props: {
    access: Object,
    row: Object
  },
  data: () => ({
    actions: [
      Model.ModuleType.Details,
      Model.ModuleType.EditStatus,
      Model.ModuleType.PrintSJ
    ]
  }),
  computed: {
    availActions() {
      const urlParams = this.$kst.Route.getParams({
        [this.$kst.Enum.Param.ID]: this.row.ID
      });

      return this.$kst.Access.getAvailableActions(
        this.actions, Model.Module, urlParams, this.access
      );
    }
  }
}
</script>